import { apiRequest } from './client';

export const uploadImage = async (imageData, publicId) => {
  const response = await apiRequest('/api/upload-image', {
    method: 'POST',
    body: JSON.stringify({ imageData, publicId }),
  });
  return response.url;
};
